module.exports = __webpack_public_path__ + "static/media/mahonpoint.bf6b64e2.png";